// extracted by mini-css-extract-plugin
export default {"board":"BoardChill_board__XGX-g","score":"BoardChill_score__pffyP","death":"BoardChill_death__L6iJr"};